import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { api } from '../../servizi/api.ts'
import { Riquadro, Scelta } from '../../componenti/base.tsx'
import { IconaCalendario } from '../../componenti/Icone.tsx'

/**
 * «Oggi in sede» nel cruscotto (559): la sede principale (o quella scelta), se oggi e' aperta e in che ore,
 * chi e' in turno e quanti appuntamenti, mediazioni e riunioni ci sono. Niente nomi di persone assistite:
 * solo i conteggi. Il collegamento porta all'agenda del giorno.
 */

type Oggi = {
  sede: { id: string; nome: string }; giorno: string
  aperta: { dalle: string; alle: string }[]; chiusa: string | null; senza_orario: boolean
  turni: { chi: string; funzione: string | null; dalle: string; alle: string; stanza: string | null }[]
  appuntamenti: number; mediazioni: number; impegni: number
  sedi: { id: string; nome: string }[]
}

const elenco = (voci: string[]) => (voci.length < 2 ? voci.join('') : `${voci.slice(0, -1).join(', ')} e ${voci.at(-1)}`)
const quanti = (n: number, uno: string, tanti: string) => (n === 1 ? `un ${uno}` : `${n} ${tanti}`)

export function OggiInSede() {
  const [sede, setSede] = useState('')
  const [dati, setDati] = useState<Oggi | null>(null)
  const [errore, setErrore] = useState(false)
  useEffect(() => {
    api.get<Oggi>(`/agenda/oggi${sede ? `?sede=${sede}` : ''}`).then((d) => { setDati(d); setErrore(false) }).catch(() => setErrore(true))
  }, [sede])
  if (errore || !dati) return null

  const orario = dati.chiusa ? `Oggi è chiusa (${dati.chiusa.charAt(0).toLowerCase()}${dati.chiusa.slice(1)}).`
    : dati.aperta.length ? `Oggi è aperta al pubblico ${elenco(dati.aperta.map((f) => `${f.dalle}–${f.alle === '00:00' ? '24:00' : f.alle}`))}.`
      : dati.senza_orario ? 'L’orario della sede non è ancora indicato.' : 'Oggi non apre al pubblico.'
  const conti = [
    dati.appuntamenti ? quanti(dati.appuntamenti, 'appuntamento', 'appuntamenti') : null,
    dati.mediazioni ? (dati.mediazioni === 1 ? 'una mediazione' : `${dati.mediazioni} mediazioni`) : null,
    dati.impegni ? (dati.impegni === 1 ? 'una riunione o prenotazione' : `${dati.impegni} riunioni e prenotazioni`) : null,
  ].filter((x): x is string => !!x)
  return (
    <Riquadro titolo={<span className="titolo-con-icona"><IconaCalendario /> Oggi in sede</span>}
              azioni={<>
                {dati.sedi.length > 1 && (
                  <Scelta etichetta="Sede" valore={sede || dati.sede.id} cambia={setSede}
                          opzioni={dati.sedi.map((s) => ({ valore: s.id, etichetta: s.nome }))} />
                )}
                <Link to={`/agenda?sede=${dati.sede.id}&vista=giorno&giorno=${dati.giorno}`}>Agenda del giorno</Link>
              </>}>
      <p className="piccolo"><strong>{dati.sede.nome}.</strong> {orario}</p>
      <p className="piccolo tenue">{conti.length ? `In agenda: ${elenco(conti)}.` : 'Niente in agenda.'}</p>
      {dati.turni.length > 0
        ? (
          <ul className="piccolo">
            {dati.turni.map((t, i) => (
              <li key={i}>{t.dalle}–{t.alle} {t.chi}{t.funzione ? `, ${t.funzione.toLowerCase()}` : ''}{t.stanza ? ` (${t.stanza})` : ''}</li>
            ))}
          </ul>
        )
        : <p className="piccolo tenue">Nessun turno segnato per oggi.</p>}
    </Riquadro>
  )
}
